var querystring_1 = require('querystring');
var extend = require('xtend');
function lowerHeader(key) {
    var lower = key.toLowerCase();
    if (lower === 'referrer') {
        return 'referer';
    }
    return lower;
}
function type(str) {
    return str == null ? null : str.split(/ *; */)[0];
}
var Base = (function () {
    function Base(_a) {
        var url = _a.url, headers = _a.headers, rawHeaders = _a.rawHeaders, query = _a.query;
        this.url = null;
        this.headers = {};
        this.headerNames = {};
        this.query = {};
        if (typeof url === 'string') {
            var queryIndexOf = url.indexOf('?');
            var queryObject = typeof query === 'string' ? querystring_1.parse(query) : query;
            if (queryIndexOf > -1) {
                this.url = url.substr(0, queryIndexOf);
                this.query = extend(queryObject, querystring_1.parse(url.substr(queryIndexOf + 1)));
            }
            else {
                this.url = url;
                this.query = extend(queryObject);
            }
        }
        if (rawHeaders) {
            this.rawHeaders = rawHeaders;
            for (var i = 0; i < rawHeaders.length; i += 2) {
                var name_1 = rawHeaders[i];
                var value = rawHeaders[i + 1];
                this.append(name_1, value);
            }
        }
        else {
            this.set(headers);
        }
    }
    Base.prototype.set = function (name, value) {
        var _this = this;
        if (typeof name !== 'string') {
            if (name) {
                Object.keys(name).forEach(function (key) {
                    _this.set(key, name[key]);
                });
            }
        }
        else {
            var lower = lowerHeader(name);
            if (value == null) {
                delete this.headers[lower];
                delete this.headerNames[lower];
            }
            else {
                this.headers[lower] = typeof value === 'string' ? value : value.join(', ');
                this.headerNames[lower] = name;
            }
        }
        return this;
    };
    Base.prototype.append = function (name, value) {
        var previous = this.get(name);
        if (previous != null) {
            value = previous + ", " + (typeof value === 'string' ? value : value.join(', '));
        }
        return this.set(name, value);
    };
    Base.prototype.name = function (name) {
        return this.headerNames[lowerHeader(name)];
    };
    Base.prototype.get = function (name) {
        var _this = this;
        if (arguments.length === 0) {
            var headers = {};
            Object.keys(this.headers).forEach(function (key) {
                headers[_this.name(key)] = _this.get(key);
            });
            return headers;
        }
        else {
            return this.headers[lowerHeader(name)];
        }
    };
    Base.prototype.remove = function (name) {
        var lower = lowerHeader(name);
        delete this.headers[lower];
        delete this.headerNames[lower];
        return this;
    };
    Base.prototype.type = function (value) {
        if (arguments.length === 0) {
            return type(this.headers['content-type']);
        }
        return this.set('Content-Type', value);
    };
    Base.prototype.fullUrl = function () {
        var url = this.url;
        var query = querystring_1.stringify(this.query);
        if (query) {
            return url + (url.indexOf('?') === -1 ? '?' : '&') + query;
        }
        return url;
    };
    return Base;
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = Base;
//# sourceMappingURL=base.js.map


//////////////////
// WEBPACK FOOTER
// ./~/popsicle/dist/lib/base.js
// module id = 39
// module chunks = 0 1